/// <reference path="./typings/index.d.ts" />
/**
 * GAサイト分析
 */
function CreateGA() {

	var p = [];
	p.push('<div>');

	/**
	 * 1-uniタグ
	 */
	p.push('<script type="text/javascript" src="//cdn.softbank.jp/shop/set/common/p/js/online-shop/analytics/unitag.js"></script>');

	/**
	 * 2-サイカタ
	 */

	var str = "";

	var hash = window.location.hash;
	
	if (hash === "#top") {
		// 手続き内容の選択
		str = "option_standard_precheck";
	} else if (hash === "#login") {
		if (params.sb == "Y") {
			// ログイン認証（回線MSN）
			str = "ysb_apply_login";
		} else {
			// ログイン認証（機種契約番号）
			str = "ysbmcn_apply_login";
		}
	} else if (hash === "#reserveLogin") {
		// 予約番号認証
		str = "nsb_apply_login";
	} else if (hash === "#deviceSelect") {
		// 機種の選択
		if (isEmpty(params.applType)) {
			// 直送通常申込
			if (isSb) {
				// SB
				if (isTerminal) {
					// 端末ログイン
					str = "ysbmcn_bis_modelselect";
				} else {
					// 回線ログイン
					str = "ysb_bis_modelselect";
				}
			} else {
				// 非SB
				str = "nsb_bis_modelselect";
			}
		} else {
			// 予約本申し込み
			if (isSb) {
				// SB
				if (isTerminal) {
					// 端末ログイン
					str = "ysbmcn_apply_modelselect";
				} else {
					// 回線ログイン
					str = "ysb_apply_modelselect";
				}
			} else {
				// 非SB
				str = "nsb_apply_modelselect";
			}
		}
	} else if (hash === "#setup") {
		// 事前注意事項
		if (isEmpty(params.applType)) {
			// 直送通常申込
			str = "nsb_bis_notes";
		} else {
			// 予約本申し込み
			str = "nsb_apply_notes";
		}
	} else if (hash === "#sbCustomerInfoEntry") {
		// お客さま情報入力（SB）
		if (isEmpty(params.applType)) {
			// 直送通常申込
			// お客さま情報入力（SB）
			if (isTerminal) {
				// 端末ログイン
				str = "ysbmcn_bis_customerinfo";
			} else {
				// 回線ログイン
				str = "ysb_bis_customerinfo";
			}
		} else {
			// 予約本申し込み
			// お客さま情報入力（SB）
			if (isTerminal) {
				// 端末ログイン
				str = "ysbmcn_apply_customerinfo";
			} else {
				// 回線ログイン
				str = "ysb_apply_customerinfo";
			}
		}
	} else if (hash === "#nonSbCustomerInfoEntry") {
		// お客さま情報入力（非SB）
		if (isEmpty(params.applType)) {
			// 直送通常申込
			str = "nsb_bis_customerinfo";
		} else {
			// 予約本申し込み
			str = "nsb_apply_customerinfo";
		}
	} else if (hash === "#pay") {
		// 支払情報入力
		if (isEmpty(params.applType)) {
			// 直送通常申込
			str = "nsb_bis_billinfo";
		} else {
			// 予約本申し込み
			str = "nsb_apply_billinfo";
		}
	} else if (hash === "#delivery") {
		// 配送情報入力
		if (isEmpty(params.applType)) {
			// 直送通常申込
			// 配送情報入力
			if (isTerminal) {
				// 端末ログイン
				str = "ysbmcn_bis_shippinginfo";
			} else {
				// 回線ログイン
				str = "ysb_bis_shippinginfo";
			}
		} else {
			// 予約本申し込み
			// 配送情報入力
			if (isTerminal) {
				// 端末ログイン
				str = "ysbmcn_apply_shippinginfo";
			} else {
				// 回線ログイン
				str = "ysb_apply_shippinginfo";
			}
		}
	} else if (hash === "#agreement") {
		// 規約同意
		if (isEmpty(params.applType)) {
			// 直送通常申込
			if (isSb) {
				// SB
				if (isTerminal) {
					// 端末ログイン
					str = "ysbmcn_bis_terms";
				} else {
					// 回線ログイン
					str = "ysb_bis_terms";
				}
			} else {
				// 非SB
				str = "nsb_bis_terms";
			}
		} else {
			// 予約本申し込み
			if (isSb) {
				// SB
				if (isTerminal) {
					// 端末ログイン
					str = "ysbmcn_apply_terms";
				} else {
					// 回線ログイン
					str = "ysb_apply_terms";
				}
			} else {
				// 非SB
				str = "nsb_apply_terms";
			}
		}
	} else if (hash === "#confirm") {
		// 申し込み内容の確認
		if (isEmpty(params.applType)) {
			// 直送通常申込
			if (isSb) {
				// SB
				if (isTerminal) {
					// 端末ログイン
					str = "ysbmcn_bis_confirm";
				} else {
					// 回線ログイン
					str = "ysb_bis_confirm";
				}
			} else {
				// 非SB
				str = "nsb_bis_confirm";
			}
		} else {
			// 予約本申し込み
			if (isSb) {
				// SB
				if (isTerminal) {
					// 端末ログイン
					str = "ysbmcn_apply_confirm";
				} else {
					// 回線ログイン
					str = "ysb_apply_confirm";
				}
			} else {
				// 非SB
				str = "nsb_apply_confirm";
			}
		}
	} else if (hash === "#identity") {
		// 必要書類送付
		if (isEmpty(params.applType)) {
			// 直送通常申込
			str = "nsb_bis_documents";
		} else {
			// 予約本申し込み
			str = "nsb_apply_documents";
		}
	} else if (hash === "#complete") {
		// 申し込み完了
		if (isEmpty(params.applType)) {
			// 直送通常申込
			if (isSb) {
				// SB
				if (isTerminal) {
					// 端末ログイン
					str = "ysbmcn_bis_finish";
				} else {
					// 回線ログイン
					str = "ysb_bis_finish";
				}
			} else {
				// 非SB
				str = "nsb_bis_finish";
			}
		} else {
			// 予約本申し込み
			if (isSb) {
				// SB
				if (isTerminal) {
					// 端末ログイン
					str = "ysbmcn_apply_finish";
				} else {
					// 回線ログイン
					str = "ysb_apply_finish";
				}
			} else {
				// 非SB
				str = "nsb_apply_finish";
			}
		}
	}
	$("body").attr("data-ga-site-catalyse-page-name", str);

	p.push('<script type="text/javascript" src="//cdn.softbank.jp/shop/set/common/p/js/online-shop/analytics/s_code.js"></script>');
	p.push(`<script type="text/javascript">
		var youbi = new Array("SUN","MON","TUE","WED","THU","FRI","SAT");
		var myDate = new Date();
		siteJson = {};
		//曜日
		var week = youbi[myDate.getDay()];
		//時間
		var hour = myDate.getHours() + "-" + (myDate.getHours()+1);

		/* You may give each page an identifying name, server, and channel onthe next lines. */
		s.pageName="${str}";
		s.server="";
		s.channel="";
		s.pageType="";
		s.prop1=week;
		s.prop2=hour;
		s.prop3="";
		s.prop4="";
		s.prop5="";
		/* E-commerce Variables */
		s.campaign="";
		s.state="";
		s.zip="";
		s.events="";
		s.products="";
		s.purchaseID="";
		s.eVar1="";
		s.eVar2="";
		s.eVar3="";
		s.eVar4=week;
		s.eVar5=hour;
		s.eVar6=document.referer;
		/************* DO NOT ALTER ANYTHING BELOW THIS LINE ! **************/
		var s_code=s.t();
		if(s_code) {
			document.write(s_code);
		}

		if(navigator.appVersion.indexOf('MSIE')>=0){
			document.write(unescape('%3C')+'\!-'+'-');
		}
		</script>`);

	/**
	 * 3-Y!ユニバーサルタグ_SB
	 */
	p.push(`<script type="text/javascript">
		(function () {
			window.addEventListener(
				"load",
				function () {
					var tagjs = document.createElement("script");
					var s = document.getElementsByTagName("script")[0];
					tagjs.async = true;
					tagjs.src = "//s.yjtag.jp/tag.js#site=pqAkEhi&referrer=" + encodeURIComponent(document.location.href) + "";
					s.parentNode.insertBefore(tagjs, s);
				},
				false
			);
		})();
	</script>`);

	/**
	 * 4-GTMスニペットタグ
	 */

	window.dataLayer = window.dataLayer || [];

	if (hash === "#complete") {
		var applicationNumber = $('#complete_loginMySoftBankTitle').text();
		var awName = $("#sliderBox .slick-current figure").attr("itemtype") + " " + $("#bandBox .checked .txt").text().trim();
		var brand = 'Apple';
		var category = 'Apple Watch';
		var dimension94 = 'APW';
		if (pageController.itemsInfoMap.get(pageController.currentItemCd).google_pixel_watch_kbn == "1") {
			brand = 'Google';
			category = 'Google Pixel Watch';
			dimension94 = 'GPW';
		}
		dataLayer.push({'pageUrl': '/' + str + '.html',
			'ecommerce': {
				'purchase': {
					'actionField': {
						'id': applicationNumber,					// （★必須★）オンライン受付番号。1購入にあたりユニークな値を入れる。トランザクション計測用。
						'affiliation': 'NEWOLS',					// （★必須★）（固定値）
						'revenue': applyRegistInfo.item_price,		// （★必須★）実際にユーザーが支払う額つまり売上額を入れる。カンマは入れなくても可。
						'tax':'0',				 		 			// （★必須★）（固定値）消費税。'0'を指定（行は消さない）
						'shipping': '0',							// （★必須★）（固定値）送料。'0'を指定（行は消さない）
						'coupon': 'NONE'							// （★必須★）クーポンコード、コードがない場合は'NONE'を指定
					},
					'products': [{									// 購入商品データ
						'id': applyRegistInfo.item_code,			// （★必須★）機種コード
						'name': pageController.currentItemNm,		// （★必須★）商品名を指定
						'price': applyRegistInfo.item_price,		// （★必須★）実際にユーザーが支払う額つまり売上額を入れる。カンマは入れなくても可。
						'brand': brand,								// （■システム的に可能であれば入れてください。■）Apple Watchの場合はAPPLE,Google Pixel Watchの場合はGoogle
						'category': category,						// （■システム的に可能であれば入れてください。■）Apple Watchの場合はApple Watch,Pixel Watchの場合はGoogle Pixel Watch
						'variant': awName,							// （■システム的に可能であれば入れてください。■）カラー。（不可の場合は行ごと削除）
						'dimension93': 'BIS',						// （■システム的に可能であれば入れてください。■）受付システム。HIGHモード予約:HEORS,予約:EORS,通常時直送予約:ORS,直送通常:BIS,店頭受取:O2Oを指定。
						'dimension94': dimension94,					// （■システム的に可能であれば入れてください。■）受付方法。新規:NEW,MNP:MNP,機変:UPG　Apple Watchの場合はAPW,Google Pixel Watchの場合はGPW
						'dimension95': 'SBM',						// （■システム的に可能であれば入れてください。■）業態。SBM:SBM,MVNO:SBPTを指定。（不可の場合は行ごと削除）
						'quantity': 1								// （★必須★）（固定値）1回の購入に1商品のため。
					}]
				}
			},
			'event': 'olsEcCV'});									// （★必須★）（固定値）
	} else {
		dataLayer.push({'pageUrl': '/' + str + '.html', 'event': 'olsEcFlow'});
	}

	/**
	 * 5-ユニタグ
	 */
	p.push(`<script type="text/javascript">
		(function(d,u){
			var b=d.getElementsByTagName("script")[0],j=d.createElement("script");
			j.async=true;
			j.src=u;b.parentNode.insertBefore(j,b);
		})
		(document,"//img.ak.impact-ad.jp/ut/mone.994b83ad016_2485.js");
		</script>`);


	p.push('</div>');

	$('iframe[name=sb_ga_transition]').remove();
	var i = document.createElement('iframe');
	i.setAttribute('style', 'display:none;');
	i.setAttribute('name', 'sb_ga_transition');
	document.body.appendChild(i);
	i.contentWindow.document.open();
	i.contentWindow.document.write(p.join('\n'));
	i.contentWindow.document.close();

}

function loadGTM () {
	// GAサイト分析
	var gaString = getEnviromentInfo(gaList);
	if (gaString) {

		// GTM
		try{
			if (navigator.appVersion.toLowerCase().indexOf("msie 6.")==-1) {
				(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
				new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
				j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
				'//www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
				})(window,document,'script','dataLayer','GTM-BMSW');
			}
		}catch(e){
		}
	}
}
loadGTM ();

/**
 * WTRタグ
 */
function loadWtr() {

	var wtrSrc = getEnviromentInfo(wtrList);
	if (wtrSrc) {
		try{
			(function(d,s){
			var timeStamp = new Date().getTime();
			var f = d.getElementsByTagName(s)[0], j = d.createElement(s);
			j.async = true;
			j.src = wtrSrc + '?mode=ajax&v=' + timeStamp;
			f.parentNode.insertBefore(j,f);
			})(document,'script');
		}catch(e){
		}
	}
}
loadWtr();